import React, { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import MapComponent from './MapComponent';
import { TextField, MenuItem, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';


const ALL_SERVICE_TYPES = [
  "Trauma-informed care",
  "Peer support",
  "Physical training & fitness",
  "Substance abuse assistance",
  "Alternative & functional health",
  "Family & marital counseling",
  "Financial support services",
  "Sports medicine specialists",
  "Legal services",
  "Insurance",
];

const ServicePage = ({ services }) => {
  const [activeService, setActiveService] = useState(null);
  const [filteredServices, setFilteredServices] = useState(services);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [resetMap, setResetMap] = useState(false);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const filtered = services.filter(service => {
      return (service.business_name.toLowerCase().includes(query) ||
              (service.is_individual && service.individual_name.toLowerCase().includes(query))) &&
             (!selectedType || service.types.includes(selectedType));
    });

    setFilteredServices(filtered);

    // Reset the map whenever the filters are changed
    setResetMap(true);
  }, [services, searchQuery, selectedType]);

  // Clear the map reset flag after it's been set
  useEffect(() => {
    if (resetMap) {
      // Use a timer to ensure it resets after re-render
      const timer = setTimeout(() => setResetMap(false), 0);
      return () => clearTimeout(timer);
    }
  }, [resetMap]);

  // Inside ServicePage component
  return (
    <div>
      <div className="search-and-filter-bar" style={{ marginBottom: -25 }}>
        <TextField
          label="Search service"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ flex: 2.5, marginRight: 10 }} // Adjust styling as needed
        />
        <TextField
          select
          label="Service Types"
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          variant="outlined"
          size="small"
          style={{ flex: 1, marginRight: 10 }} // Adjust styling as needed
        >
          <MenuItem value="">
            <em>All Service Types</em>
          </MenuItem>
          {[...new Set([...services.flatMap(service => service.types), ...ALL_SERVICE_TYPES])]
          .sort((a, b) => ALL_SERVICE_TYPES.indexOf(a) - ALL_SERVICE_TYPES.indexOf(b))
          .map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <MapComponent
        services={filteredServices}
        activeService={activeService}
        resetMap={resetMap}
        key={selectedType + searchQuery} // Add a dynamic key that changes on filter/search
      />
      <div className="services-gallery">
        {filteredServices.map(service => (
          <ServiceCard
            key={service.business_name}
            service={service}
            onClick={() => {
              setActiveService(service);
              setResetMap(false); // Ensures map doesn't reset when a service card is clicked
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicePage;
